import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerDepotFacade } from './customer-depot.facade';
import { DepotOverview } from '@models/resources/depot.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante (Sprint 5c S5c-8). Active when
 * `environment.dataSource === 'http'`.
 *
 * Wire-Contract: `GET /api/me/depot` → V4 `DepotOverviewResource`
 * (siehe `backend/app/Http/Resources/DepotOverviewResource.php`).
 *
 * `JsonResource::withoutWrapping()` ist global gesetzt, deshalb kommt
 * der Resource-Array ohne `data`-Envelope.
 *
 * **V4-Wire-Shape vs FE-V3-Model**: das aktuelle FE-`DepotOverview`-
 * Interface (gold/silver, `weight_g`, `hero_value_net_eur`) wird in
 * S5c-9 (4-Metalle-Refactor) an die V4-Wire-Shape angepasst (Au/Ag/Pt/Pd,
 * `quantity_grams`, `total_value_net_eur`). Bis dahin bleibt der
 * Typ-Hint hier nominal — die Facade pass-through't den BE-Payload
 * ohne Mapping.
 */
@Injectable()
export class HttpCustomerDepotFacade implements CustomerDepotFacade {
  private readonly http = inject(HttpClient);

  getOverview(): Observable<DepotOverview> {
    return this.http.get<DepotOverview>(`${environment.apiUrl}/me/depot`);
  }
}
